// import { useState } from "react";

export const stateData = [
  {
    id: 0,
    state: 0,
    img: "/statics/images/state0.svg",
    imgActive: "/statics/images/state0-active.svg",
  },
  {
    id: 1,
    state: 1,
    img: "/statics/images/state1.svg",
    imgActive: "/statics/images/state1-active.svg",
  },
  {
    id: 2,
    state: 2,
    img: "/statics/images/state2.svg",
    imgActive: "/statics/images/state2-active.svg",
  },
  {
    id: 3,
    state: 3,
    img: "/statics/images/state3.svg",
    imgActive: "/statics/images/state3-active.svg",
  },
  {
    id: 4,
    state: 4,
    img: "/statics/images/state4.svg",
    imgActive: "/statics/images/state4-active.svg",
  },
];
export const arrow = (
  <>
    <img
      src='/statics/images/arrow-down.svg'
      width='12'
      height='12'
      className='DownArrow '
      alt='DownArrow'
    />
  </>
);
export const arrow_down = (
  <>
    <img
      src='/statics/images/arrow-down.svg'
      width='12'
      height='12'
      className='DownArrow '
      alt='DownArrow'
    />
  </>
);
export const arrow_up = (
  <>
    <img
      src='/statics/images/arrow-up.svg'
      width='18px'
      // height='16px'
      className='arrow '
      alt='arrow'
    />
  </>
);

export const navdata = [
  {
    id: 0,
    img: "home.svg",
    img_hover: "home-blue.svg",
    title: "خانه",
    href: "/",
  },
  {
    id: 1,
    img: "nav-users-white.svg",
    img_hover: "nav-users-blue.svg",
    title: "کاربران",
    href: "/users",
  },
  {
    id: 2,
    img: "nav-req-white.svg",
    img_hover: "nav-req-blue.svg",
    title: "درخواست‌ها",
    href: "/requests",
  },
  {
    id: 3,
    img: "nav-ads-white.svg",
    img_hover: "nav-ads-blue.svg",
    title: "کالاها",
    href: "/products",
  },
  {
    id: 4,
    img: "nav-ads-white.svg",
    img_hover: "nav-ads-blue.svg",
    title: "گزارشات",
    href: "/reports",
  },
];

export const MONTH = (type) => {
  switch (type) {
    case 1:
      return "فروردین";
    case 2:
      return "اردیبهشت";
    case 3:
      return "خرداد";
    case 4:
      return "تیر";
    case 5:
      return "مرداد";
    case 6:
      return "شهریور";
    case 7:
      return "مهر";
    case 8:
      return "آبان";
    case 9:
      return "آذر";
    case 10:
      return "دی";
    case 11:
      return "بهمن";
    case 12:
      return "اسفند";

    default:
      return "";
  }
};

export const DAY = (type) => {
  switch (type) {
    case "Sat":
      return "شنبه";
    case "Sun":
      return "یکشنبه";
    case "Mon":
      return "دوشنبه";
    case "Tue":
      return "سه‌شنبه";
    case "Wed":
      return "چهارشنبه";
    case "Thu":
      return "پنچ‌شنبه";
    case "Fri":
      return "جمعه";

    default:
      return "";
  }
};

export const promotedata = [
  {
    id: 0,
    title1: "پلن برنزی",
    title2: "پلن یک ماهه",
    features: [
      "قرار گرفتن آگهی دربالاترین اولویت",
      "بیشترین بازدید از اگهی",
      "کسب امتیاز بیشتر برای ارتقاء اگهی",
    ],
    coins: 30,
    price: "300000",
    color: "#f0884e",
    icon: "promote1.svg",
    planimage: "promote-coins1.svg",
  },
  {
    id: 1,
    title1: "پلن نقره‌ای",
    title2: "پلن دو ماهه",
    features: [
      "قرار گرفتن آگهی دربالاترین اولویت",
      "بیشترین بازدید از اگهی",
      "کسب امتیاز بیشتر برای ارتقاء اگهی",
    ],
    coins: 60,
    price: "560000",
    color: "#aaa9ad",
    icon: "promote2.svg",
    planimage: "promote-coins2.svg",
  },
  {
    id: 2,
    title1: "پلن طلایی",
    title2: "پلن سه ماهه",
    features: [
      "قرار گرفتن آگهی دربالاترین اولویت",
      "بیشترین بازدید از اگهی",
      "کسب امتیاز بیشتر برای ارتقاء اگهی",
    ],
    coins: 130,
    price: "1000000",
    color: "#ffda40",
    icon: "promote3.svg",
    planimage: "promote-coins3.svg",
  },
];

export const profilemenu = [
  {
    id: 0,
    title: "حساب کاربری",
    icon_blue: "profile-account.svg",
    icon_white: "profile-account-white.svg",
  },
  {
    id: 1,
    title: "درخواست های من ",
    icon_blue: "profile-req.svg",
    icon_white: "profile-req-white.svg",
  },
  {
    id: 2,
    title: "آگهی های من",
    icon_blue: "profile-ad.svg",
    icon_white: "profile-ad-white.svg",
  },
  {
    id: 3,
    title: "لیست علاقه مندی ها",
    icon_blue: "profile-favorite.svg",
    icon_white: "profile-favorite-white.svg",
  },
  {
    id: 4,
    title: "دعوت از دوستان",
    icon_blue: "profile-invite.svg",
    icon_white: "profile-invite-white.svg",
  },
  {
    id: 5,
    title: "نظرات من",
    icon_blue: "profile-comment.svg",
    icon_white: "profile-comment-white.svg",
  },
  {
    id: 6,
    title: "پلن‌های من",
    icon_blue: "profile-plan.svg",
    icon_white: "profile-plan-white.svg",
  },
];

export const optiontypes = [
  { id: 0, name: "string" },
  { id: 1, name: "float" },
  { id: 2, name: "integer" },
  { id: 3, name: "bool" },
  { id: 4, name: "choice" },
  { id: 5, name: "manual" },
  { id: 6, name: "point" },
];
